import useSWR from 'swr';
import { ResponseWrapper } from '@tlx/astro-shared';
import { APIUrls } from '@Util/urls';

export type TskContext = {
    companyName: string;
    hasDepartment: boolean;
    hasEmployeeCategory: boolean;
    hasDivision: boolean;
    maxEmployeesPerSalaryTransaction: number;
    contextCompanyId: number;
    loginEmployeeId: number;
    actualEmployeeId: number;
    isProxyLogin: boolean;
    isPilotSalaryRun: boolean;
    isShowSalaryOnboarding: boolean;
    isPayInAdvance: boolean;
    isTestAccount: boolean;
    isLoading: boolean;
    userDepartmentId: number;
    showDepartmentIsWageAdmin: boolean;
    showDepartmentIsEmployeeAdmin: boolean;
    showOldPage: boolean;
    authLevelWage: number;
    authLevelEmployeeOrWage: number;
};

type TskContextEndpointValues = {
    companyName: string;
    hasDepartment: boolean;
    hasEmployeeCategory: boolean;
    hasDivision: boolean;
    maxEmployeesPerSalaryTransaction: number;
    contextCompanyId: number;
    loginEmployeeId: number;
    actualEmployeeId: number;
    isProxyLogin: boolean;
    isPilotSalaryRun: boolean;
    isShowSalaryOnboarding: boolean;
    isPayInAdvance: boolean;
    isTestAccount: boolean;
    userDepartmentId: number;
    isNewCustomerFrom2025: boolean;
    authLevelWage: number;
    authLevelEmployeeOrWage: number;
};

export const AUTH_LEVEL_COMPANY = 3;
export const AUTH_LEVEL_DEPARTMENT = 2;
export const AUTH_LEVEL_READ_ONLY = 1;
export const AUTH_LEVEL_NONE = 0;

export function useTskContext(): TskContext {
    const { data, isLoading } = useSWR<ResponseWrapper<TskContextEndpointValues>>(APIUrls.TSK_CONTEXT, {
        refreshWhenHidden: true,
    });

    return {
        companyName: data?.value?.companyName ?? '',
        hasDepartment: data?.value?.hasDepartment ?? false,
        hasEmployeeCategory: data?.value?.hasEmployeeCategory ?? false,
        hasDivision: data?.value?.hasDivision ?? false,
        maxEmployeesPerSalaryTransaction: data?.value?.maxEmployeesPerSalaryTransaction ?? 0,
        contextCompanyId: data?.value.contextCompanyId ?? 0,
        loginEmployeeId: data?.value.loginEmployeeId ?? 0,
        actualEmployeeId: data?.value.actualEmployeeId ?? 0,
        isProxyLogin: data?.value.isProxyLogin ?? false,
        isPilotSalaryRun: data?.value?.isPilotSalaryRun ?? true,
        isShowSalaryOnboarding: data?.value?.isShowSalaryOnboarding ?? false,
        isPayInAdvance: data?.value?.isPayInAdvance ?? false,
        isTestAccount: data?.value?.isTestAccount ?? false,
        isLoading: isLoading,
        userDepartmentId: data?.value?.userDepartmentId ?? 0,
        showDepartmentIsWageAdmin:
            (data?.value?.hasDepartment && data?.value?.authLevelWage == AUTH_LEVEL_COMPANY) ?? false,
        showDepartmentIsEmployeeAdmin:
            (data?.value?.hasDepartment && data?.value?.authLevelEmployeeOrWage == AUTH_LEVEL_COMPANY) ?? false,
        showOldPage: (!data?.value?.isNewCustomerFrom2025 && !data?.value?.isTestAccount) ?? false,
        authLevelWage: data?.value.authLevelWage ?? 0,
        authLevelEmployeeOrWage: data?.value.authLevelEmployeeOrWage ?? 0,
    };
}
